module.exports = __webpack_public_path__ + "img/s1v2.cf7c7351.jpeg";